import { render } from "./KeyResultsSmall.vue?vue&type=template&id=73ff2d1d&scoped=true"
import script from "./KeyResultsSmall.vue?vue&type=script&lang=js"
export * from "./KeyResultsSmall.vue?vue&type=script&lang=js"

import "./KeyResultsSmall.vue?vue&type=style&index=0&id=73ff2d1d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-73ff2d1d"

export default script